import { Component, booleanAttribute, input } from '@angular/core';

@Component({
  selector: 'knx-page-header',
  host: {
    class: 'block border-b border-border bg-background',
  },
  templateUrl: './page-header.component.html',
})
export class PageHeaderComponent {
  padded = input(true, { alias: 'knxPadded', transform: booleanAttribute });
}
